import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * A custom element that displays a product's pot size based on the selected variant.
 * This component listens for variant update events and updates the pot size display accordingly.
 */
class ProductPotSize extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePotSize);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePotSize);
  }

  /**
   * Updates the pot size display when a variant is selected.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updatePotSize = (event) => {
    // Check if this update is for the correct product
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    // Find the updated pot size element in the new HTML
    const newPotSize = event.detail.data.html.querySelector('product-pot-size');
    
    if (!newPotSize) return;

    // Use morph to update the content, just like product-price and product-inventory
    morph(this, newPotSize, { childrenOnly: true });
  };
}

// Register the custom element
if (!customElements.get('product-pot-size')) {
  customElements.define('product-pot-size', ProductPotSize);
}

export default ProductPotSize; 